import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims`;

export interface CreateClaimForOwnerCommandArgs {
  ownerId: string;
  ownerProductId: string;
}

export const createClaimForOwnerRequest = ({
  ownerId,
  ownerProductId,
}: CreateClaimForOwnerCommandArgs): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: {
    method: SUPPORTED_METHODS.POST,
    json: { ownerId, ownerProductId },
  },
});

export const createClaimForOwnerCommand = async (
  args: CreateClaimForOwnerCommandArgs,
): Promise<BackResponse<string> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<string>>(
      createClaimForOwnerRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
